import { AlphaIIcon } from './AlphaIIcon';

/**
 * author: GreenTurtwig
 * id C34618B6-174E-42C7-AD23-B65FCAC93D74
 * name alpha-i
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-i.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetIIcon = AlphaIIcon;
export default AlphabetIIcon